import { ActiveStepStore } from "src/store/onboarding.store";
import { StepItem } from "./types";
import {
  AddCogsMaterial,
  CheckMarketIntelligenceMaterial,
  ConnectAmazonAccountsMaterial,
  MarketIntelligenceMaterial,
  SetupMarketShareMaterial,
  WhatIfScenarioMaterial,
  WhatIsNyleMaterial,
} from "./descriptionBlocks";

export const stepConfig: Record<
  number,
  {
    title: string;
    buttonLabel: string;
    description?: JSX.Element;
    getStepItems?: () => StepItem[];
  }
> = {
  0: {
    title: "What is Nyle?",
    buttonLabel: "NEXT",
    description: <WhatIsNyleMaterial />,
  },
  1: {
    title: "Connect Your Amazon Accounts",
    buttonLabel: "CONNECT",
    description: <ConnectAmazonAccountsMaterial />,
  },
  2: {
    title: "Add COGS to Get ASIN-Level ROI",
    buttonLabel: "ADD COGS",
    description: <AddCogsMaterial />,
  },
  3: {
    title:
      "Market Intelligence: How to Set Up Market Share Goals to Grow Your Business",
    buttonLabel: "CONTINUE",
    description: <MarketIntelligenceMaterial />,
    getStepItems: () => {
      const { subStepsCompleted } = ActiveStepStore.getState();
      return [
        {
          completed: subStepsCompleted[3][0],
          title: "Check Market Intelligence Insights",
          description: <CheckMarketIntelligenceMaterial />,
        },
        {
          completed: subStepsCompleted[3][1],
          title: "Try What If Scenarios",
          description: <WhatIfScenarioMaterial />,
        },
      ];
    },
  },
  4: {
    title: "Setup Market Share Goal",
    buttonLabel: "GO TO CANVAS",
    description: <SetupMarketShareMaterial />,
  },
};
